var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBowlingAlley40PxSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bowling-alley",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 58,
    viewBox: "0 0 40 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 55,
    r: 3,
    fill: "#FF2E00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,48,34.142,33.521a19.531,19.531,0,0,0,5.474-10.054,19.315,19.315,0,0,0-1.138-11.345,19.725,19.725,0,0,0-7.367-8.813,20.309,20.309,0,0,0-22.222,0,19.725,19.725,0,0,0-7.367,8.813A19.315,19.315,0,0,0,.384,23.467,19.531,19.531,0,0,0,5.858,33.521Z",
    fill: "#FF2E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(12.5,12.5)",
    fill: "#ffffff",
    id: "icon_concepts:_sports_leisure",
    d: "M8.83,5.39a11.0127,11.0127,0,0,0-.96,4.28,11.4686,11.4686,0,0,0,.58,3.69A4.9424,4.9424,0,0,1,6,14,5,5,0,1,1,8.98,4.99C8.94,5.12,8.88,5.25,8.83,5.39ZM4.12,8.5a.62.62,0,1,0-.62.62h0a.6105.6105,0,0,0,.62-.6009C4.12,8.5128,4.12,8.5064,4.12,8.5ZM4.5,7.12a.62.62,0,1,0-.62-.62h0a.6106.6106,0,0,0,.6011.62ZM6.12,8.5a.62.62,0,1,0-.62.62h0a.6105.6105,0,0,0,.62-.6009C6.12,8.5128,6.12,8.5064,6.12,8.5Zm4.8022-5.3341c0-.7222-.1444-.7222-.1444-1.4444a.7222.7222,0,0,1,1.4444-.0007v.0007c0,.7222-.1444.7222-.1444,1.4444,0,2.1667,1.5528,3.6168,1.5528,6.5,0,2.1667-.6861,4.3333-1.4083,4.3333H10.7778c-.7222,0-1.4083-2.1667-1.4083-4.3333C9.3694,6.7826,10.9222,5.3325,10.9222,3.1659Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowlingAlley40PxSelected);
export default __webpack_public_path__ + "static/media/bowling-alley_40px_selected.890198590f23f9aad53b870388bfb9cb.svg";
export { ForwardRef as ReactComponent };